var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimerCurvedBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1053,
    height: 420,
    viewBox: "0 0 1053 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M967.054 397.173c114.496-42.504 138.496-398.346-85-374.535C658.555 46.45 112.709-73.87 41.554 79.144c-71.155 153.014-57 302.528 90 318.029 147 15.502 721 42.504 835.5 0z",
    fill: "#EDF1F9"
  })));
}

export default __webpack_public_path__ + "./fonts/timer-curved-bg.637f56b330ab815acb7462a2d560a838.svg";
export { SvgTimerCurvedBg as ReactComponent };